import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss']
})
export class RadioComponent implements OnInit {

  @Input() checked
  @Input() name
  @Input() choiceValue
  @Input() displayText
  @Input() id

  @Output() returnSelectValue = new EventEmitter

  constructor() { }

  ngOnInit() {
  }

  selectChoice(event) {
    this.returnSelectValue.emit(event)
  }

}
